export default __webpack_public_path__ + "static/media/CLI-SEN-POW.8704836b.png";